import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useRef, useState } from 'react';
import { Button } from '@/components/common';
import { AccountSubpageShell } from '@/components/layout';
import { EDIT_PROFILE_FORM_ID, EditProfile, type EditProfileHandle } from '@/components/profile';
import { useCurrentUser } from '@/contexts';

export function EditProfilePage() {
  const navigate = useNavigate();
  const { t } = useTranslation('profile');
  const { currentUser: profile } = useCurrentUser();
  const [saving, setSaving] = useState(false);
  const editProfileRef = useRef<EditProfileHandle | null>(null);

  if (!profile) return null;

  return (
    <AccountSubpageShell
      onBack={() => editProfileRef.current?.handleBack()}
      right={
        <Button
          type="submit"
          form={EDIT_PROFILE_FORM_ID}
          variant="outline"
          color="gray"
          highContrast
          radius="full"
          size="sm"
          fullWidth={false}
          disabled={saving}
          isLoading={saving}
        >
          {t('edit.actions.save')}
        </Button>
      }
    >
      <EditProfile
        ref={editProfileRef}
        profile={profile}
        onSavingChange={setSaving}
        onBack={() => navigate('/account/my-profile')}
        onUpdate={() => {
          // Profile doc updates are applied via useUserProfile subscription.
        }}
      />
    </AccountSubpageShell>
  );
}
